import { OrderStatusNames, OrderStatusNameToLabel, PermissionFlagName } from 'lib/types';
import { ADMIN_TABS } from 'containers/Admin/adminTabs';
import _ from 'lodash';

export interface IMenuItemConfig {
    id: string;
    path: string;
    label: string | ((additionalTabName?: string) => string);
    permissionKey: string | PermissionFlagName;
    requiresDesktop?: boolean;
    subItems?: IMenuItemConfig[];
    showAsDropdownOnMobile?: boolean;
    mobileSubmenuContainer?: boolean; // for nested submenus
    hideIf?: (user: any) => boolean;
}

export const generateOrdersSubItems = (): IMenuItemConfig[] => Array.from(_.map(OrderStatusNames, (status) => ({
    id: `orders-${status}`,
    path: `/orders/${status}`,
    label: OrderStatusNameToLabel[status],
    permissionKey: 'orders',
    hideIf: status === 'unauthorized' ? (user: any) => !user?.authEnabled : undefined
})));

export const NAVBAR_TABS: IMenuItemConfig[] = [
    {
        id: 'news',
        path: '/news',
        label: 'Aktualności',
        permissionKey: 'news'
    },
    {
        id: 'orders',
        path: '/orders',
        label: 'Zamówienia',
        permissionKey: 'orders',
        showAsDropdownOnMobile: true,
        subItems: generateOrdersSubItems()
    },
    {
        id: 'new-order',
        path: '/new-order',
        label: 'Nowe zamówienie',
        permissionKey: 'new-order'
    },
    {
        id: 'settlements',
        path: '/settlements',
        label: 'Rozliczenia',
        permissionKey: 'settlements'
    },
    {
        id: 'promotions',
        path: '/promotions',
        label: 'Wspólne korzyści',
        permissionKey: 'promotions',
        showAsDropdownOnMobile: true,
        subItems: [
            {
                id: 'promotions-articles',
                path: '/promotions/articles',
                label: 'Artykuły promocyjne',
                permissionKey: 'promotions' // inherit view permission
            },
            {
                id: 'promotions-orders',
                path: '/promotions/orders',
                label: 'Zamówienia na artykuły promocyjne',
                permissionKey: 'promotions'
            },
            {
                id: 'promotions-users',
                path: '#',
                label: 'Użytkownicy',
                permissionKey: 'promotions',
                mobileSubmenuContainer: true,
                subItems: [
                    { id: 'register-roofer', path: '/promotions/register-roofer', label: 'Rejestruj dekarza', permissionKey: 'register-roofer' },
                    { id: 'register-trader', path: '/promotions/register-trader', label: 'Rejestruj handlowca', permissionKey: 'register-trader' },
                    { id: 'manage-traders', path: '/promotions/manage-traders', label: 'Administracja handlowcami', permissionKey: 'manage-traders' }
                ]
            },
            {
                id: 'promotions-terms',
                path: '#',
                label: 'Jak to działa?',
                permissionKey: 'promotions',
                mobileSubmenuContainer: true,
                subItems: [
                    { id: 'terms', path: '/promotions/terms', label: 'Regulamin', permissionKey: 'promotions' },
                    { id: 'promotion-regulations', path: '/promotions/promotion-regulations', label: 'Zasady działania programu promocyjnego', permissionKey: 'promotions' }
                ]
            }
        ]
    },
    {
        id: 'isod',
        path: '/isod',
        label: 'ISOD',
        permissionKey: 'isod',
        requiresDesktop: true // not shown on mobile
    },
    {
        id: 'account',
        path: '/account',
        label: 'Konto',
        permissionKey: 'account'
    },
    {
        id: 'admin',
        path: '/admin',
        label: 'Admin',
        permissionKey: 'admin',
        showAsDropdownOnMobile: true,
        subItems: _.map(ADMIN_TABS, (tab) => ({
            id: `admin-${tab.pathSuffix}`,
            path: `/admin/${tab.pathSuffix}`,
            label: tab.title,
            permissionKey: tab.permissionKey
        }))
    },
    {
        id: 'additional-tab',
        path: '/additional-tab',
        label: (additionalTabName) => additionalTabName || 'Dodatkowa zakładka',
        permissionKey: 'additional-tab'
    },
    {
        id: 'settings',
        path: '/settings',
        label: 'Ustawienia',
        permissionKey: 'settings'
    }
];
